import { ButtonBase } from '@mui/material';
import * as React from 'react';


export default function CustomButton({ title, press, textColor, fontSize, backgroundColor, borderStyle, marginLeft, marginRight, height, width, borderRadius, paddingInline, padding, disabled }) {

    return (
        <>
            <ButtonBase
                style={{
                    padding: padding || 7,
                    paddingInline: paddingInline || 17,
                    fontSize: fontSize || 14,
                    fontWeight: 500,
                    color: textColor || '#505D69',
                    backgroundColor: backgroundColor || 'white',
                    border: borderStyle || '0px',
                    borderRadius: borderRadius || '5px',
                    marginLeft: marginLeft || 0,
                    marginRight: marginRight || 0,
                    minHeight: height ? 0 : 40,
                    height: height && height,
                    width: width && width,
                }}
                disabled={disabled}
                onClick={() => press()}
            >
                {title}
            </ButtonBase>
        </>
    );
}
